import e from "./indexTable.ce.vue.js";
import { defineAndRegisterElement as o } from "../../utils/register-element.js";
const t = o(e);
export {
  t as initApprovalTable
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/approval-table/index.js
// module id = 1215
// module chunks = 67